export default [{
  title: 'The Colors',
  artist: 'Pablo Picasso',
  releaseInfo: '1909 Spanish Records',
  albumCover: '/assets/images/album_covers/01.jpg',
  slug: 'the-colors',
  songs: [
      { title: 'Blue', duration: '161.71', audioSrc: '/assets/music/blue.mp3' },
      { title: 'Green', duration: '103.96', audioSrc: '/assets/music/green.mp3' },
      { title: 'Red', duration: '268.45', audioSrc: '/assets/music/red.mp3' },
      { title: 'Pink', duration: '153.14', audioSrc: '/assets/music/pink.mp3' },
      { title: 'Magenta', duration: '374.22', audioSrc: '/assets/music/magenta.mp3' }
  ]
}, {
    title: 'The Telephone',
    artist: 'Guglielmo Marconi',
    releaseInfo: '1909 EM',
    albumCover: '/assets/images/album_covers/02.jpg',
    slug: 'the-telephone',
    songs: [
      { title: 'Blue', duration: '161.71', audioSrc: '/assets/music/blue.mp3' },
      { title: 'Green', duration: '103.96', audioSrc: '/assets/music/green.mp3' },
      { title: 'Red', duration: '268.45', audioSrc: '/assets/music/red.mp3' },
      { title: 'Pink', duration: '153.14', audioSrc: '/assets/music/pink.mp3' },
      { title: 'Magenta', duration: '374.22', audioSrc: '/assets/music/magenta.mp3' }
    ]
}];
